import { render, staticRenderFns } from "./ServiceShow.vue?vue&type=template&id=88d41cc0&scoped=true&"
import script from "./ServiceShow.vue?vue&type=script&lang=js&"
export * from "./ServiceShow.vue?vue&type=script&lang=js&"
import style0 from "./ServiceShow.vue?vue&type=style&index=0&id=88d41cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d41cc0",
  null
  
)

export default component.exports